export const countWords = (txt: string) => {
  return txt
    ?.trim()
    .split(" ")
    .filter((x) => x.trim().length > 0).length;
};
